import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="customelementregistry" id="customelementregistry"></a>
    <h1 {...{
      "id": "windowcustomelementregistry"
    }}>{`window.CustomElementRegistry`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: Refer `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry"
      }}>{`Web APIs - CustomElementRegistry`}</a>{`  `}</p>
    <a name="customelementregistry-define" id="customelementregistry-define"></a>
    <h2 {...{
      "id": "definename-constructor-options"
    }}>{`define(name, constructor, options)`}</h2>
    <p>{`Defines a new custom element.`}</p>
    <p><strong parentName="p">{`See`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/define"
        }}>{`CustomElementRegistry - define`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://html.spec.whatwg.org/multipage/custom-elements.html#element-definition"
        }}>{`HTML Spec - Element definition`}</a></li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name for the new custom element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`constructor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`CustomElement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constructor for the new custom element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Object that controls how the element is defined`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.extends`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of a built-in element to extend`}</td>
        </tr>
      </tbody>
    </table>
    <a name="customelementregistry-get" id="customelementregistry-get"></a>
    <h2 {...{
      "id": "getname"
    }}>{`get(name)`}</h2>
    <p>{`Returns the constructor for the named custom element`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/get"
      }}>{`CustomElementRegistry - get`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the custom element`}</td>
        </tr>
      </tbody>
    </table>
    <a name="customelementregistry-upgrade" id="customelementregistry-upgrade"></a>
    <h2 {...{
      "id": "upgraderoot"
    }}>{`upgrade(root)`}</h2>
    <p>{`Upgrade all potential custom elements under tree rooted at 'root'.`}</p>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade"
      }}>{`CustomElementRegistry - upgrade`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`root`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Node instance with shadow-containing descendant elements to upgrade`}</td>
        </tr>
      </tbody>
    </table>
    <a name="customelementregistry-whendefined" id="customelementregistry-whendefined"></a>
    <h2 {...{
      "id": "whendefinedname"
    }}>{`whenDefined(name)`}</h2>
    <p>{`Returns a Promise that resolves when the named custom-element is defined.`}</p>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/whenDefined"
      }}>{`CustomElementRegistry - whenDefined`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The name of the custom element`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      